import hexRgb from 'hex-rgb';

export default class ColorResource {
  public static getRgbValue(color?: string | null): string {
    try {
      if (typeof color !== 'string') {
        return '';
      }

      if (color.includes('rgba')) {
        return this.rgbaToRgb(color);
      }

      if (color.includes('rgb')) {
        return this.extractRgbValues(color);
      }

      return this.hexToRgb(color);
    } catch {
      return '';
    }
  }

  public static adjustColorOpacity(color: string | null | undefined, opacity: number): string {
    if (!color) {
      return '';
    }

    const rgbaMatch = color.match(/rgba?\((\d+), (\d+), (\d+)(?:, ([\d.]+))?\)/);
    if (rgbaMatch) {
      const [, r, g, b, a] = rgbaMatch;
      const newOpacity = opacity * (a ? parseFloat(a) : 1);

      return `rgba(${r}, ${g}, ${b}, ${newOpacity})`;
    }

    const hexMatch = color.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
    if (hexMatch) {
      let hex = hexMatch[1];
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map((char) => char + char)
          .join('');
      }

      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    return color;
  }

  private static rgbaToRgb(rgba: string): string {
    const match = rgba.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d*\.?\d+)\)/) as Array<string>;

    return this.getRgbValues(match);
  }

  private static extractRgbValues(rgb: string): string {
    const match = rgb.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/) as Array<string>;
    if (match) {
      return this.getRgbValues([match[1], match[2], match[3]]);
    }

    return '';
  }

  private static getRgbValues(values: string[] | number[]): string {
    return `${values[0]} ${values[1]} ${values[2]}`;
  }

  private static hexToRgb(hex: string): string {
    return this.getRgbValues(hexRgb(hex, { format: 'array' }).slice(0, 3));
  }
}
